import type { KidFormat } from '../../../../generated-types';
import { validateMod10CheckSum, validateMod11CheckSum } from './validateModService';

export const validKid = (kidFormats: KidFormat[] | undefined, kid?: string): boolean => {
    if (!kidFormats?.length) return true;
    if (!kid || kid.length < 3) return false;
    if (!kidFormats || !kidFormats.some((format) => format.length)) return false;
    const validFormat = kidFormats.filter((kidFormat) => {
        return (
            kidFormat.length === kid.length &&
            (kidFormat.modulus === 11 ? validateMod11CheckSum(kid, true) : validateMod10CheckSum(kid))
        );
    });

    return validFormat.length !== 0;
};
